import { useApiData } from '../useApiData';
import { setDictionary } from '../../store/dictionary/actions';

export const useDictionaryApi = () => {
    useApiData('/translations', setDictionary);
};
